import React from 'react';

import easybrainColor from '@src/asset/partners/easybrain-color.png';
import easybrainGray from '@src/asset/partners/easybrain-gray.png';
import fmgamesColor from '@src/asset/partners/fmgames-color.png';
import fmgamesGray from '@src/asset/partners/fmgames-gray.png';
import gamovationColor from '@src/asset/partners/gamovation-color.png';
import gamovationGray from '@src/asset/partners/gamovation-gray.png';
import ilyonColor from '@src/asset/partners/ilyon-color.png';
import ilyonGray from '@src/asset/partners/ilyon-gray.png';
import lessmoreColor from '@src/asset/partners/lessmore-color.png';
import lessmoreGray from '@src/asset/partners/lessmore-gray.png';
import miniclipColor from '@src/asset/partners/miniclip-color.png';
import miniclipGray from '@src/asset/partners/miniclip-gray.png';

interface IPartnerLogo {
  name: string;
  gray: string;
  color: string;
}

const partnerLogos: IPartnerLogo[] = [
  { name: 'Miniclip', gray: miniclipGray, color: miniclipColor },
  { name: 'Easybrain', gray: easybrainGray, color: easybrainColor },
  { name: 'FM Games', gray: fmgamesGray, color: fmgamesColor },
  { name: 'Gamovation', gray: gamovationGray, color: gamovationColor },
  { name: 'Ilyon', gray: ilyonGray, color: ilyonColor },
  { name: 'Lessmore', gray: lessmoreGray, color: lessmoreColor },
];

function Partners() {
  return (
    <div className="odc-partners">
      <span className="odc-partners-label">Partners</span>
      <div className="odc-partners-list">
        {partnerLogos.map((logo) => (
          <span className="odc-partners-logo" key={logo.name}>
            <img
              className="odc-partners-logo-gray"
              src={logo.gray}
              alt={logo.name}
            />
            <img
              className="odc-partners-logo-color"
              src={logo.color}
              alt=""
            />
          </span>
        ))}
      </div>
    </div>
  );
}

export default Partners;
